import React from 'react';
import { cn } from '@/lib/utils';
import { EmailProvider, useGetPersonalEmailSetupUrl } from '../../api/useOAuthEmailIntegration';

interface SVGButtonProps {
    src: string;
    value: EmailProvider;
    objectStyle?: React.CSSProperties;
}

const SignInButton = ({ value, src, objectStyle }: SVGButtonProps) => {
    const { trigger } = useGetPersonalEmailSetupUrl();

    const handleOnClick = async () => {
        const { url } = await trigger(value);
        window.open(url, '_self');
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleOnClick();
        }
    };

    return (
        <div
            className={cn(
                'flex w-max cursor-pointer outline-0',
                '[&:hover>object]:shadow-md',
                '[&:focus>object]:shadow-none [&:focus>object]:brightness-90',
            )}
            role="button"
            tabIndex={0}
            onClick={handleOnClick}
            onKeyDown={handleKeyDown}
        >
            <object
                tabIndex={-1}
                data={src}
                aria-label="sign in personal email"
                style={{ pointerEvents: 'none', ...objectStyle }}
            />
        </div>
    );
};

export default SignInButton;
